import { z } from "zod";
import { positionSchema } from "../shared/position";

/**
 * Accepts slider output [value] or raw number
 * Returns a single numeric zoom level
 */
export const zoomSchema = z
  .number({
    error: "Please enter a zoom level",
  })
  .min(2, "Zoom must be between 2 and 20")
  .max(20, "Zoom must be between 2 and 20");

export const mapFormSchema = z.object({
  zoom: zoomSchema,

  darkMapUrl: z.url("Please enter a valid Dark Map URL"),

  lightMapUrl: z.url("Please enter a valid Light Map URL"),

  satelliteMapUrl: z.url("Please enter a valid Satellite Map URL"),

  showSatellite: z.boolean(),

  position: positionSchema,
});

export type MapForm = z.infer<typeof mapFormSchema>;
